// Same phases, filters and URL parameters as the desktop dashboard board
// (mastermind_dashboard/src/features/tasks/layouts/board.jsx), so a link can
// move between both without losing its filters.

export const BOARD_COLUMNS = [
    { key: 'pending', title: 'Pendiente', states: ['proposed', 'ready'], defaultOrder: 'asc' },
    { key: 'claimed', title: 'En progreso', states: ['claimed'], defaultOrder: 'asc' },
    { key: 'review', title: 'En revisión', states: ['in_review'], defaultOrder: 'asc' },
    { key: 'done', title: 'Hecho', states: ['done'], defaultOrder: 'desc' },
];

// States outside the columns are surfaced, never dropped: a blocked task that
// vanished from the board is the one nobody remembers to unblock.
export const ASIDE_STATES = ['blocked', 'returned', 'discarded'];

export const BOARD_STATES = [...BOARD_COLUMNS.flatMap((column) => column.states), ...ASIDE_STATES];

export const PENDING_FILTERS = [
    { key: '', label: 'Todas', states: ['proposed', 'ready'] },
    { key: 'propuestas', label: 'Propuestas', states: ['proposed'] },
    { key: 'listas', label: 'Listas', states: ['ready'] },
];

export const BOARD_PARAMS = Object.freeze({
    PROJECT: 'project',
    REPOSITORY: 'repo',
    TIER: 'tier',
    FINDINGS: 'hallazgos',
    PENDING: 'pendiente',
    PHASE: 'fase',
    VIEW: 'vista',
});

const ORDERS = ['asc', 'desc'];

function toPositiveId(value) {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

export function readBoardFilters(params) {
    const projectId = toPositiveId(params.get(BOARD_PARAMS.PROJECT));
    return {
        projectId,
        repositoryId: toPositiveId(params.get(BOARD_PARAMS.REPOSITORY)),
        // A tier only narrows inside a project, as on desktop.
        tierId: projectId ? toPositiveId(params.get(BOARD_PARAMS.TIER)) : null,
        showFindings: params.get(BOARD_PARAMS.FINDINGS) === 'mostrar',
        pending: PENDING_FILTERS.find((item) => item.key === (params.get(BOARD_PARAMS.PENDING) || '')) ?? PENDING_FILTERS[0],
    };
}

export function columnOrder(params, column) {
    const value = params.get(`orden_${column.key}`) || params.get('orden');
    return ORDERS.includes(value) ? value : column.defaultOrder;
}

export function sortById(tasks, order) {
    const direction = order === 'desc' ? -1 : 1;
    return [...tasks].sort((a, b) => direction * (a.id - b.id));
}

export function phaseIndex(params) {
    const index = BOARD_COLUMNS.findIndex((column) => column.key === params.get(BOARD_PARAMS.PHASE));
    return index >= 0 ? index : 0;
}

export function isFinding(task) {
    return task?.originTaskId != null;
}

// Findings are hidden by default: once authorized they are ordinary work, and
// a board full of "this other thing is also broken" buries the planned tasks.
export function splitFindings(tasks, show) {
    if (show) return { visible: tasks, hidden: 0 };
    const visible = tasks.filter((task) => !isFinding(task));
    return { visible, hidden: tasks.length - visible.length };
}

// Exact when the whole state was loaded; otherwise the server total is kept
// and flagged, because findings outside the loaded page cannot be counted.
export function visibleCount({ total, loaded, hidden }) {
    if (loaded >= total) return { count: Math.max(0, total - hidden), exact: true };
    return { count: total, exact: hidden === 0 };
}

export function countActiveFilters(filters) {
    return [filters.repositoryId, filters.tierId, filters.showFindings].filter(Boolean).length;
}
